import { Fancybox } from "@fancyapps/fancybox";

document.addEventListener("DOMContentLoaded", function() {
  if (document.getElementsByClassName('container-product').length > 0) {
    if (document.querySelectorAll('[data-fancybox="gallery"]').length > 0) {
      if (Fancybox) {
        Fancybox.fromSelector('[data-fancybox="gallery"]');
      }
    }
  }
  
  if (document.getElementsByClassName('solution-wrapper').length > 0) {
    // add data-fancybox to solution .paragraph--type--media-texte img
    let solutionWrapper = document.getElementsByClassName('solution-wrapper')[0];
    let solutionImages = solutionWrapper.querySelectorAll('.paragraph--type--media-texte img');
    solutionImages.forEach(function(image) {
      image.setAttribute('data-fancybox', 'gallery');
    });
    if (document.querySelectorAll('[data-fancybox="gallery"]').length > 0) {
      if (Fancybox) {
        Fancybox.fromSelector('[data-fancybox="gallery"]');
      }
    }
  }


});
